import { render, staticRenderFns } from "./CallList.vue?vue&type=template&id=601e452d&scoped=true"
import script from "./CallList.vue?vue&type=script&lang=js"
export * from "./CallList.vue?vue&type=script&lang=js"
import style0 from "./CallList.vue?vue&type=style&index=0&id=601e452d&prod&lang=less&scoped=true"
import style1 from "./CallList.vue?vue&type=style&index=1&id=601e452d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601e452d",
  null
  
)

export default component.exports